<div class="info-item info-post-enq1">
  <img [src]="assets.inqInfoImg1" class="text-img eng_only" alt="Info 1" />
  <img [src]="assets.postEnqInfoArImg1" class="text-img ar_only" alt="Info 1" />
  <img [src]="assets.postEnqInfoMlImg1" class="text-img ml_only" alt="Info 1" />
</div>
<div class="info-item info-post-enq2">
  <img [src]="assets.inqInfoImg2" class="text-img eng_only" alt="Info 2" />
  <img [src]="assets.postEnqInfoArImg2" class="text-img ar_only" alt="Info 2" />
  <img [src]="assets.postEnqInfoMlImg2" class="text-img ml_only" alt="Info 2" />
</div>
<div class="info-item info-post-enq3">
  <img [src]="assets.inqInfoImg3" class="text-img eng_only" alt="Info 3" />
  <img [src]="assets.postEnqInfoArImg3" class="text-img ar_only" alt="Info 2" />
  <img [src]="assets.postEnqInfoMlImg3" class="text-img ml_only" alt="Info 2" />
</div>
